module.exports = __webpack_public_path__ + "img/avatar2.b2b00e38.png";